module.exports = __webpack_public_path__ + "research.jpg?ab01ca507ff7e596fa989706040293f5";


//////////////////
// WEBPACK FOOTER
// ./src/images/research.jpg
// module id = 144
// module chunks = 0